{
  "placeholder": false,
  "support": {
    "description": "Something wrong with a booking, or a car that won't unlock? Message us and a person answers.",
    "channels": [
      { "label": "admin@carii.org", "href": "mailto:admin@carii.org" },
      { "label": "WhatsApp +60 18-579 8832", "href": "https://wa.me/60185798832", "newTab": true }
    ]
  },
  "careers": {
    "description": "We're a small team building the next CARii services. No open roles listed — tell us what you'd want to build.",
    "channels": [{ "label": "admin@carii.org", "href": "mailto:admin@carii.org" }]
  }
}
